export enum EUserActivityQueryKey {
  LIST_USER_ACTIVITIES = 'list-user-activities',
}
